/**
 * 3666  ===> "1:01:06"
 * 182   ===> "3:22"
 * 42    ===> "0:42"
 *
 * @param t
 */
export function secondsToTime(t: number): string {
    const h = Math.floor(t / 3600);
    const m = Math.floor((t / 60) % 60);
    const s = Math.floor(t % 60);

    const hs = h === 0 ? '' : (''+h+':');
    const ms = ((m<10 && h>0) ? ('0'+m) : (''+m))+':' ;
    const ss = s<10 ? ('0'+s) : (''+s);

    return hs+ms+ss;
}